import { Subheading } from "../../../design/heading";
import { Document } from "../../../models/Document";
import { DocumentGenerationMethod } from "../../../models/DocumentGenerationMethod";

interface ChooseGenerationMethodProps {
  generationMethod: DocumentGenerationMethod | undefined;
  setGenerationMethod: React.Dispatch<
    React.SetStateAction<DocumentGenerationMethod | undefined>
  >;
}

const options: {
  value: DocumentGenerationMethod;
  label: string;
  description: string;
}[] = [
  {
    value: "manual",
    label: "Manual",
    description: "Create documents manually",
  },
  {
    value: "ai",
    label: "AI",
    description: "Generate documents using AI",
  },
  {
    value: "template",
    label: "Template",
    description: "Use templates to create documents",
  },
  // {
  //   value: "professional",
  //   label: "Professional",
  //   description: "Get documents created by professionals",
  // },
];

const ChooseGenerationMethod: React.FC<ChooseGenerationMethodProps> = ({
  generationMethod,
  setGenerationMethod,
}) => {
  return (
    <div className="grid justify-center w-full max-w-3xl grid-cols-1 gap-4 mt-8 sm:grid-cols-2 md:grid-cols-3">
      {options.map((value) => (
        <div
          key={value.value}
          className={`flex flex-col items-center w-full p-6 rounded-lg shadow-md cursor-pointer transition-colors ${
            generationMethod === value.value
              ? "bg-blue-100 dark:bg-blue-900"
              : "bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700"
          }`}
          onClick={() => {
            setGenerationMethod(value.value);
          }}
        >
          {/* <img
                src={assets[key as keyof typeof assets]}
                alt={key}
                className="w-24 h-24 mb-3"
                /> */}
          <Subheading>{value.label}</Subheading>
        </div>
      ))}
    </div>
  );
};

export default ChooseGenerationMethod;
